<template>
	<div class="about">
		<div class="title-box">
			<img src="@/assets/images/title_about.png"/>
		</div>
		
		<div class="main">
			<div class="left">
				<img src="@/assets/images/about_pic.png"/>
			</div>
			<div class="right">
				<img src="@/assets/images/title_about_1.png"/>
				<p>鹿优选是一家创新引领的购物平台，专注于通过大数据技术为新青年定制智能化的商品推荐，精准满足个性化需求。</p>
			</div>
		</div>
		
		<div class="bg"></div>
		
		<div class="btm">
			<div class="in">
				<p>我们的专注<br/>让购物变得更加简单 。</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {},
	}
</script>

<style scoped lang="less">
	.about{
		padding-top: 0.9rem;
		background: #FBFBFB;
	}
	.title-box{
		margin-bottom: .4rem;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: .6rem;
		}
	}
	.bg{
		height: 1.72rem;
		background: #F9F3E9;
		border-radius: 0 .4rem .4rem 0;
		position: absolute;
		left: 0;
		top: 2rem;
		right: 10%;
	}
	.main{
		display: flex;
		flex-direction: column;
		padding-bottom: .8rem;
		position: relative;
		z-index: 2;
		.left{
			display: flex;
			justify-content: center;
			margin-bottom: .4rem;
			img{
				width: 2.4rem;
				height: auto;
			}
		}
		.right{
			padding: 0 .4rem;
			img{
				width: 2rem;
				height: auto;
				margin-bottom: 30px;
			}
			p{
				color: #252525;
				font-size: .16rem;
				font-weight: 400;
			}
		}
	}
	.btm{
		background:#FF4F6A url("../../assets/images/about_btm_bg.png") no-repeat right center;
		background-size: auto 100%;
		.in{
			color: #fff;
			display: flex;
			align-items: center;
			font-size: .26rem;
			font-weight: bold;
			padding: .4rem 0 .4rem .4rem;
		}
	}
</style>
